/*
 * ClosesFieldFlyout class, contains logic for closing flyouts that contain fields (ex: address field)
 * inputs:
 *   options.showFlyout: function that will show the flyout
 *   options.hideFlyout: function that will hide the flyout
 *   options.mainInput: jquery result containing the mainInput object
 *   options.flyoutSelector: jquery selector that locates the flyout div
 *   options.flyoutButtonSelector: jquery selector that locates the flyout button
 *   options.disableKeyPress: optional bool, default is true
 *   options.onKeyPress: optional function that takes in a keyCode and is called on keypress, only called if disableKeyPress is true
 */
function ClosesFieldFlyout(options) {
  if (options.disableKeyPress == null) options.disableKeyPress = true;

  // for closing the flyout when you click off
  $(document).click(function (e) {
    if ($(e.target).closest(options.flyoutSelector).length == 0)
      options.hideFlyout();
  });

  var $lastClicked;
  $(document).mousedown(function (e) {
    $lastClicked = $(e.target);
  });

  var notLastClickedInFlyout = function () {
    if (!$lastClicked) return true;
    return $lastClicked.closest(options.flyoutSelector).length == 0;
  }

  var notLastClickedFlyoutButton = function () {
    if (!$lastClicked) return true;
    return $lastClicked.closest(options.flyoutButtonSelector).length == 0;
  }

  // for closing the flyout when you tab out
  $(options.flyoutSelector + ' input').on('blur', function () {
    if (notLastClickedInFlyout() && notLastClickedFlyoutButton()) {
      setTimeout(function () {
        if ($(options.flyoutSelector + ' input:focus').length == 0)
          options.hideFlyout();
      }, 10);
    }
    $lastClicked = null;
  });

  if (options.disableKeyPress) {
    // for opening the flyout when you type a printable key
    options.mainInput.keypress(function (e) {
      options.showFlyout();

      if (options.onKeyPress != null)
        options.onKeyPress(e.keyCode);
      return false;
    });

    options.mainInput.keydown(function (e) {
      if ([8, 46].indexOf(e.keyCode) != -1) { // backspace, delete
        options.showFlyout();
        return false;
      }
    });
  }

  // for opening the flyout when you type an arrow key
  options.mainInput.keydown(function (e) {
    var arrowKeys;
    if (options.disableKeyPress)
      arrowKeys = [37, 38, 39, 40]; // all arrows
    else
      arrowKeys = [40]; // down arrow

    if (arrowKeys.indexOf(e.keyCode) != -1)
      options.showFlyout();

    var hideKeys;
    if (options.disableKeyPress)
      hideKeys = [27]; // esc
    else
      hideKeys = [27, 13]; // and enter

    if (hideKeys.indexOf(e.keyCode) != -1)
      options.hideFlyout();
  });

  // for closing the flyout when you hit ESC
  $(options.flyoutSelector).keyup(function (e) {
    if (e.keyCode == 27) // esc
      options.hideFlyout();
  });
}
